import { Inject, Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { ActionPerformed, PushNotifications, PushNotificationSchema, Token } from '@capacitor/push-notifications';
import { Badge } from '@capawesome/capacitor-badge';
import { UserService } from './user.service';
import { ENVIRONMENT } from '../core.constants';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(
    private userService: UserService,
    @Inject(ENVIRONMENT) private environment: any,
    private router: Router,
  ) {}

  initPush() {
    if (Capacitor.getPlatform() !== 'web') {
      this.registerPush();
    }
  }

  async tryNavigateToUrl() {
    const url = localStorage.getItem('pendingNotificationUrl');
    if (!url) return;

    const isLogged = await firstValueFrom(this.userService.user$); // tu método para comprobar sesión
    if (isLogged) {
      this.router.navigateByUrl(url);
      localStorage.removeItem('pendingNotificationUrl');
    }
  }

  private registerPush() {
    PushNotifications.requestPermissions().then((permission: any) => {
      if (permission.receive === 'granted') {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
      } else {
        // No permission for push granted
      }
    });

    PushNotifications.addListener('registration', (token: Token) => {
      if (!this.environment.production) {
        console.log('My token: ' + token.value);
      }
      const fcmToken =
        this.environment.appType === 'maroc' ? { fcmTokenMaroc: token.value } : { fcmTokenTunisie: token.value };
      this.userService.updateUserData(fcmToken);
    });

    PushNotifications.addListener('registrationError', (error: any) => {
      console.log('Error: ' + JSON.stringify(error));
    });

    PushNotifications.addListener('pushNotificationReceived', async (notification: PushNotificationSchema) => {
      console.log('Push received: ' + JSON.stringify(notification));
    });

    PushNotifications.addListener('pushNotificationActionPerformed', async (notification: ActionPerformed) => {
      console.log('Action performed: ' + JSON.stringify(notification));
      const url = notification.notification.data?.url;
      if (url) {
        localStorage.setItem('pendingNotificationUrl', url);
        this.tryNavigateToUrl();
      }
    });
  }

  async resetBadgeCount() {
    if (Capacitor.getPlatform() === 'web') return;

    // Clear badge independently — don't let push notification errors block it
    try {
      await Badge.clear();
    } catch (error) {
      console.warn('Error clearing badge:', error);
    }

    try {
      await PushNotifications.removeAllDeliveredNotifications();
    } catch {
      // Push may not be registered yet (e.g. simulator), ignore
    }

    try {
      await this.userService.updateUserData({ badgeCount: 0 });
    } catch (error) {
      console.warn('Error resetting badge count in Firestore:', error);
    }
  }
}
